import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConciliacaoApiService } from '../services/conciliacao-api.service';
import { DadosConciliacao } from '../models/dados-conciliacao';

@Injectable()
export class NovaConciliacaoResolver implements Resolve<DadosConciliacao> {

  constructor(
    private conciliacaoApiService: ConciliacaoApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<DadosConciliacao> {
    const contaId: number = router.params['contaId'];
    const dadosConciliacao: Observable<DadosConciliacao> = this.conciliacaoApiService.getDadosConciliacaoNova(contaId);

    return zip(dadosConciliacao).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}